import React, { useEffect, useState } from 'react';

// Components
import { toast } from 'react-toastify';

// Custom components
import { BackdropLoading } from '../../../BackdropLoading';

// API
import { ContractApi } from '../../../../services/ContractApi';

// Styles
import { Container, Header, Body, Footer, SectionRight, Spacer, } from './styles'
import { FormButton } from '../../../../pages/styles';

// Utils
import { Auth } from "../../../../utils/auth";
import { CheckResponse } from '../../../../utils/checkResponse';
import { Contractor } from '../../../molecules/forms/Contractor';
import { useTranslation } from 'react-i18next';

// Permissions
import { useAbility } from '@casl/react';
import { AbilityContext } from '../../../../Context/PermissionsContext';

export const ContractorModalCard = ({ data, handleSave, handleClose }) => {

    const contractApi = new ContractApi();
    const { check } = new CheckResponse();
    const { getUser } = new Auth();
    const { t } = useTranslation();
    const ability = useAbility(AbilityContext);

    const plantList = React.useRef([])
    const users = React.useRef([])

    const [form, setForm] = useState({
        id: 0,
        contractor: '',
        contractorId: '',
        contractId: '',
        code: '',
        plants: [],
        contractsPlants: [],
        contractors: [],
        companyId: 0
    })
    const [formSupervisor, setFormSupervisor] = useState({
        id: 0,
        username: '',
        plants: []
    })
    const refContractors = React.useRef([])
    const refSupervisor = React.useRef({ plants: [] })
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        async function call() {
            setLoading(true)

            // await getContractors()
            await getContractData(data?.id)
            await getSupervisors(data?.id)

            setLoading(false)
        }
        call()
    }, [])

    function checkItems(array) {

        return array.map(item => ({
            ...item,
            hasEmptyPlants: item.plants.length === 0,
            errorEmptyPlants: item.plants.length === 0 ? t("system.validations.mandatory") : '',
            hasEmptyContractors: item.contractor === '',
            errorEmptyContractors: item.contractor === '' ? t("system.validations.mandatory") : ''
        }))
    }

    const validateForm = () => {
        let hasError = false;
        let array = form.contractors

        // Solo se valida si existen contratistas agregados al listado
        if (array.length > 0 && array[0]?.id !== undefined) {
            array = checkItems(array)
            setForm({...form, contractors: array})
    
            const hasEmptyPlants = array.some(item => item.hasEmptyPlants);
            const hasEmptyContractor = array.some(item => item.hasEmptyContractors);
    
            if (hasEmptyPlants || hasEmptyContractor) hasError = true;
        }

        return hasError;
    }

    async function getContractors(contractId) {
        let response = await contractApi.getContractorExecutors(contractId)
        let result = check(response)

        if (result.status) {
            let contractors = response.data?.map(item => {
                const contractor = `${item?.identification ?? ''} - ${item?.name ?? ''} ${item?.lastName ?? ''}`;
                return { ...item, contractor };
            }) || [];
            contractors.sort((a, b) => a.contractor.localeCompare(b.contractor, undefined, { sensitivity: 'base' }));

            users.current = contractors
        }
        else {
            toast.error(() => <>{result.errors}</>)
        }
    }

    async function getContractData(id) {
        let response = await contractApi.getContractorData(id);
        let result = check(response)
        if (result.status) {
            let data = response.data
            let contractorsData;
            if (data.contractors.length > 0) {
                contractorsData = data.contractors.map((item) => { return { ...item, contractor: `${item?.identification ?? ''} - ${item?.name ?? ''} ${item?.lastName ?? ''}` } })
            } else {
                contractorsData = [...emptyContractorRow()]
            }
            let contractorPlants = data.plants.map((item) => { return { ...item, disabled: false } })

            refContractors.current = contractorsData
            plantList.current = data.plants

            let companyId = data.contract?.company?.id ?? 0

            setForm({
                ...form,
                id: data.contract.id,
                code: data.contract.code,
                contractor: "",
                plants: contractorPlants,
                contractorId: "",
                contractors: contractorsData,
                companyId: companyId
            })

            await getContractors(companyId)
            checkAvailableContractors(contractorsData)
        }
        else {
            toast.error(() => <>{result.errors}</>)
        }
    }

    async function getSupervisors(id) {
        let response = await contractApi.getSupervisorData(id);
        let result = check(response)
        if (result.status) {
            let data = response.data

            const user = getUser();
            const supervisor = data.technicalSupervisors.find(item => item.username === user.username) || { plants: [] };
            refSupervisor.current = supervisor
            setFormSupervisor({
                ...formSupervisor,
                ...supervisor
            })
            checkAndSetDisabled()
        }
        else {
            toast.error(() => <>{result.errors}</>)
        }
    }

    // Función para verificar y agregar la propiedad "disabled"
    const checkAndSetDisabled = () => {

        // recorrer el plantList y agregar el disabled
        let arrSupervisor = refSupervisor.current
        const updatedPlants = plantList.current.map(plant => ({
            ...plant,
            disabled: !arrSupervisor.plants.some(item => item.id === plant.id)
        }))
        // setPlantList(updatedPlants)
        plantList.current = updatedPlants

    };

    const emptyContractorRow = () => {
		return [
			{
                contractor: '',
                plants: []
			}
		]
	}

    function handleAddRow() {
		let array = form.contractors

        array = checkItems(array)

        const hasEmptyPlants = array.some(item => item.hasEmptyPlants);
        const hasEmptyContractor = array.some(item => item.hasEmptyContractors);

		if (!hasEmptyPlants && !hasEmptyContractor) array.push(...emptyContractorRow())

		setForm({...form, contractors: array})
	}

    function handleRemoveRow(index) {
		let array = form.contractors
		array.splice(index, 1)

		if (array.length === 0) {
			array = emptyContractorRow()
		}

		setForm({...form, contractors: array})
		checkAvailableContractors(array)
	}

    function handleChange(name, value, idx) {
        let contractors = [...form.contractors]

        if (name === 'contractors'){
            // Se conservan las plantas asignadas previamente
            let tempPlants = contractors[idx]?.plants ?? []
            contractors[idx] = value;
            contractors[idx].plants = tempPlants;
        } else if (name === 'plants') {
            contractors[idx]['plants'] = value;
        }

        setForm({...form, contractors})
        checkAvailableContractors(contractors)
    }

    function checkForm() {
        let invalidate = validateForm()
        if (invalidate) return

        handleSave(form)
    }

    function checkAvailableContractors(items) {
		let contractorUsers = [...users.current]
        let arrayIds = []
        arrayIds = items?.map((user) => user.id)

        contractorUsers.map((obj) => {
            if (arrayIds.includes(obj.id)) obj.isDisabled = true
            else obj.isDisabled = false
        })

        users.current = contractorUsers
	}


    return (
        <Container>
            <Header>{t('contract.assignContractor')}</Header>
            <Body>
                <Contractor
                    form={form}
                    users={users.current}
                    handleChange={handleChange}
                    plantList={plantList.current}
                    handleAddRow={handleAddRow}
                    handleRemoveRow={handleRemoveRow}
                    disabled={loading}
                />
            </Body>
            <Footer>
                <SectionRight>
                    <FormButton
                        variant="outlined"
                        type="close"
                        onClick={() => handleClose(false)}
                    >
                        {t('common.cancel')}
                    </FormButton>
                    <Spacer />
                    {ability.can("UpdateContractor") &&
                        <FormButton
                            variant="contained"
                            onClick={checkForm}
                        >
                            {t('common.save')}
                        </FormButton>
                    }

                </SectionRight>
            </Footer>
            <BackdropLoading open={loading} />
        </Container>
    )
}